const mutations = {
  setSms(state, data) {
    state.smsEdit = data
  },
  setDeleteSms(state, data) {
    state.smsDelete = data
  }
}

export default mutations